import * as Types from '../../../generated/index'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type CreateFileArchiveMutationVariables = Types.Exact<{
  signedIds: Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
  filename?: Types.InputMaybe<Types.Scalars['String']['input']>
}>

export type CreateFileArchiveMutation = {
  createFileArchive?: { url?: string | null; errors: Array<string> } | null
}

export const CreateFileArchiveDocument = gql`
  mutation createFileArchive($signedIds: [String!]!, $filename: String) {
    createFileArchive(signedIds: $signedIds, filename: $filename) {
      url
      errors
    }
  }
`
export type CreateFileArchiveMutationFn = Apollo.MutationFunction<
  CreateFileArchiveMutation,
  CreateFileArchiveMutationVariables
>

/**
 * __useCreateFileArchiveMutation__
 *
 * To run a mutation, you first call `useCreateFileArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFileArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFileArchiveMutation, { data, loading, error }] = useCreateFileArchiveMutation({
 *   variables: {
 *      signedIds: // value for 'signedIds'
 *      filename: // value for 'filename'
 *   },
 * });
 */
export function useCreateFileArchiveMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateFileArchiveMutation,
    CreateFileArchiveMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<CreateFileArchiveMutation, CreateFileArchiveMutationVariables>(
    CreateFileArchiveDocument,
    options
  )
}
export type CreateFileArchiveMutationHookResult = ReturnType<typeof useCreateFileArchiveMutation>
export type CreateFileArchiveMutationResult = Apollo.MutationResult<CreateFileArchiveMutation>
export type CreateFileArchiveMutationOptions = Apollo.BaseMutationOptions<
  CreateFileArchiveMutation,
  CreateFileArchiveMutationVariables
>
